import { render, staticRenderFns } from "./buy_process_dia.vue?vue&type=template&id=668f065a&"
import script from "./buy_process_dia.vue?vue&type=script&lang=js&"
export * from "./buy_process_dia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports